import { IPayoutRequisite, IPayoutTicket } from '../payoutTickets.types'

/**
 * CPAYMENT-1713: a payout may carry several client requisites of different kinds (a card and an SBP
 * phone). Responses that predate the feature only have `externalUserRequisite`, so every screen reads
 * the payout's channels through here instead of touching either field directly.
 */
export const payoutRequisites = (ticket: IPayoutTicket): IPayoutRequisite[] => {
  if (ticket.userRequisites?.length) {
    return ticket.userRequisites
  }

  const legacy = ticket.externalUserRequisite
  if (!legacy) {
    return []
  }

  return [
    {
      requisiteKind: '',
      type: legacy.type ?? '',
      identifier: legacy.identifier ?? '',
      currency: legacy.currency ?? '',
      acquiringBank: legacy.acquiringBank ?? null,
      cardholder: legacy.cardholder ?? null,
    },
  ]
}

const KIND_LABELS: Record<string, string> = {
  bank_card: 'Карта',
  phone_number: 'Телефон (СБП)',
  bank_account: 'Счёт',
  crypto_wallet: 'Кошелёк',
  redirect_url: 'Ссылка',
  wallet: 'Кошелёк (телефон)',
}

/** Human label for one channel: the requisite kind when known, the method type otherwise. */
export const requisiteKindLabel = (requisite: IPayoutRequisite): string =>
  KIND_LABELS[requisite.requisiteKind] || requisite.type || '-'

/**
 * Column label for the ticket lists. A single-channel payout keeps showing its method type, exactly
 * as before; a composite one lists its kinds, because the primary requisite's method would name only
 * half of what the payout accepts.
 */
export const payoutTypeLabel = (ticket: IPayoutTicket): string => {
  const requisites = payoutRequisites(ticket)

  if (requisites.length === 0) {
    return '-'
  }
  if (requisites.length === 1) {
    return requisites[0].type || '-'
  }

  return requisites.map(requisiteKindLabel).join(' + ')
}
